module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#f7f7f7"
    }
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "head-user",
    attrs: {
      "to": "/main"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "productList"
  }, [_vm._m(0), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "80%",
      "background-color": "#f05634",
      "margin": "1rem auto"
    },
    attrs: {
      "type": "warn"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.32rem"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v("开通免费云服务器请电脑登录PC版")])]), _vm._v(" "), _c('div', {
    staticClass: "pro_content"
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('div', {
      staticClass: "pro_listItem",
      class: {
        'active': _vm.showA == index
      },
      on: {
        "click": function($event) {
          _vm.listDown(index)
        }
      }
    }, [_c('div', {
      staticClass: "pro_ItemTitle"
    }, [_c('span', {
      staticClass: "icon_bef",
      class: item.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "pro_itemCont"
    }, [_c('p', [_vm._v(_vm._s(item.content))])])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "contact-us"
  }, [_c('div', {
    staticClass: "contact_top"
  }, [_c('div', {
    staticClass: "nav-links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("支付方式")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agreement"
    }
  }, [_vm._v("服务条款")])], 1)])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "home"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_title"
  }, [_c('h4', [_vm._v("免费云服务器参数")]), _vm._v(" "), _c('p', [_vm._v("【CPU：1核】【内存：1G】【带宽：5M】")]), _vm._v(" "), _c('p', [_vm._v("【数据盘：10G】【送免备案系统】")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_bottom clearfix"
  }, [_c('a', {
    staticClass: "logo-bottom",
    attrs: {
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weixin-b"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "0.32rem"
    },
    attrs: {
      "href": "https://www.abeiyun.com"
    }
  }, [_vm._v("切换电脑版")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_bottom_r"
  }, [_vm._v("\n          ©2018 abeiyun All rights reserved\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7313fae2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/freeserver.vue
// module id = Kf2I
// module chunks = 1